import { useEffect } from "react";

const useUnload = (params) => {
  useEffect(() => {
    const handleBeforeUnload = (evt) => {
      if (params.when) {
        evt.returnValue = params.message;
        return params.message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [params]);
};

export default useUnload;
